module.exports = __webpack_public_path__ + "img/wa-hover.55941562.png";